import image1 from "../assets/t-image1.jpg";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'TRACY BOAKYE',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Fitclub makes it fun and enjoyable to workout. The trainers there are very professional and encouraging ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:'Fitclub has provided excellent support, education and encouragement. The flexible training hours and location are perfect for my needs.',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
